<template>
    <div>
        <v-dialog v-model="dialog" max-width="1024" scrollable>
            <v-card>
                <v-card-title>
                    Informações da Instância
                    <v-spacer></v-spacer>
                    <v-btn icon @click=" dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="zcinstancia.zci_nome" label="Nome da Instância" type="text" required
                                :disabled="dialogLoading" prepend-icon="label"
                                :readonly="(!userSiczap || !userMaster || zcinstancia.id > 0)" />
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="zcinstancia.zci_nomesessao" label="Nome da Sessão" type="text"
                                :disabled="dialogLoading" :readonly="true" prepend-icon="label" />
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="zcinstancia.zci_idinstancia" label="ID da Instância" type="text"
                                required :disabled="dialogLoading" :readonly="true" prepend-icon="mdi-key"
                                v-if="exibirCampos" />
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="zcinstancia.zci_tokeninstancia" label="Token da Instância"
                                type="text" required :disabled="dialogLoading" :readonly="true" prepend-icon="mdi-key"
                                v-if="exibirCampos" />
                        </v-col>

                        <v-col cols="12" sm="6" md="12">
                            <v-text-field v-model="zcinstancia.zci_webhookurl_statusmsg"
                                label="Url Webhook Status Mensagem" type="link" :disabled="dialogLoading"
                                :readonly="exibirCampoUrlWebHook" prepend-icon="mdi-link" v-if="exibirCampos" />
                        </v-col>

                        <!-- <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="zcinstancia.zci_webhookrl_msgentregue"
                                label="Url Webhook mensagem entregue" type="link" :disabled="dialogLoading"
                                :readonly="true" prepend-icon="mdi-link" v-if="exibirCampos" />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="zcinstancia.zci_webhookurl_disconnected"
                                label="Url Webhook instância conectada" type="text" required :disabled="dialogLoading"
                                :readonly="true" prepend-icon="mdi-link" v-if="exibirCampos" />
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-text-field v-model="zcinstancia.zci_webhookurl_connected"
                                label="Url Webhook instância desconectada" type="text" required
                                :disabled="dialogLoading" :readonly="true" prepend-icon="mdi-link"
                                v-if="exibirCampos" />
                        </v-col> -->

                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="red" dark v-if="exibirBtnAssinar"
                        @click="abrirConfirmacao('Deseja realmente assinar a instância?', () => assinarZcinstancia())"
                        :loading="loadingAssinarInstancia">
                        Assinar Instância?
                    </v-btn>
                    <v-spacer></v-spacer>

                    <v-btn color="blue" dark v-show="exibirBtnSalvar"
                        @click="abrirConfirmacao('Deseja realmente salvar?', () => atualizarZcinstancia())"
                        :loading="loadingSalvar" >
                        Salvar
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <!-- Dialog de confirmação -->
        <v-dialog v-model="dialogConfirm" max-width="400">
            <v-card>
                <v-card-title class="text-h6">Confirmação</v-card-title>
                <v-card-text>
                    {{ confirmMessage }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialogConfirm = false">Cancelar</v-btn>
                    <v-btn text color="primary" @click="executarConfirmacao()">Confirmar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card>
            <v-card-title>
                <v-icon left color="primary">mdi-whatsapp</v-icon>Instâncias
                <v-spacer></v-spacer>
                <v-btn class="white--text" color="primary" elevation="2" v-if="exibirBtnNovo"
                    @click="abrirConfirmacao('Deseja realmente criar uma nova instância?', () => confirmarSalvar())"
                    :loading="loadingNovo" :disabled="loadingNovo">
                    <v-icon left> mdi-plus </v-icon>
                    Nova Instância
                </v-btn>

            </v-card-title>
            <v-card-text>

                <v-row>
                    <v-col cols="12" sm="12" md="3">
						<v-checkbox v-model="disponivel" label="Disponíveis para vincular em novos clientes"></v-checkbox>
					</v-col>
					<v-col cols="12" sm="6" md="3">
						<v-checkbox v-model="pendente" label="Não vinculadas/Nem assinadas"></v-checkbox>
					</v-col>
					<v-col cols="12" sm="6" md="3">
						<v-checkbox v-model="indisponivel" label="Já vinculadas em uso"></v-checkbox>
					</v-col>
                </v-row>

                <v-data-table :headers="headers" :items="zcinstancias" class="elevation-1" :loading="loading"
                    @click:row="loadZcinstancia" pagi>

                    <template v-slot:[`item.clienteId`]="{ item }">
                        <v-icon color="red" v-if="item.clienteId > 0" title="Não">mdi-cancel</v-icon>
                        <v-icon color="green" v-if="item.clienteId === null" title="Sim">check_circle_outline</v-icon>
                    </template>

                    <template v-slot:[`item.zci_assinado`]="{ item }">
                        <v-icon color="green" v-if="item.zci_assinado == true" title="Sim">check_circle_outline</v-icon>
                        <v-icon color="red" v-if="item.zci_assinado == false" title="Não">mdi-cancel</v-icon>
                    </template>

                    <template v-slot:[`item.createdAt`]="{ item }">
                        {{ convertDate(item.createdAt) }}
                    </template>

                    <template v-if="(userSiczap || userMaster)" v-slot:[`item.acao`]="{ item }">
                        <v-btn title="Excluir Instância" icon
                            @click.stop="abrirConfirmacao('Deseja realmente excluir a instância?', () => cancelaZcinstancia(item.id))"
                            :loading="loadingCancelar === item.id" :disabled="loadingCancelar === item.id">
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    data: function () {
        return {
            zcinstancias: [],
            headers: [
                { text: 'Descrição', value: 'zci_nome' },
                { text: 'Sessão', value: 'zci_nomesessao' },
                { text: 'Id Instância', value: 'zci_idinstancia' },
                { text: 'Token Instância', value: 'zci_tokeninstancia' },
                { text: 'Instância disponível?', value: 'clienteId' },
                { text: 'Instância assinada?', value: 'zci_assinado' },
                { text: 'Data criação', value: 'createdAt' },
                { text: 'Ação', value: 'acao' },
            ],
            loading: false,
            loadingNovo: false,
            loadingCancelar: null,
            loadingSalvar: false,
            loadingAssinarInstancia: false,
            dialogLoading: false,
            dialog: null,
            zcinstancia: {},
            dialogConfirm: false,
            confirmMessage: '',
            confirmAction: null,
            disponivel: true,
            pendente: false,
            indisponivel: false
        }
    },
    computed: {
        ...mapGetters(['userSiczap', 'userMaster']),
        exibirBtnAssinar() {
            return !this.loading && this.zcinstancia.id && (this.userSiczap || this.userMaster) && this.zcinstancia.zci_assinado == false
        },
        exibirCampos() {
            return this.zcinstancia.id > 0
        },
        exibirCampoUrlWebHook() {
            return this.zcinstancia.zci_assinado == false
        },
        exibirBtnNovo() {
            return (this.userSiczap || this.userMaster)
        },
        exibirBtnSalvar() {
            return this.zcinstancia.zci_assinado
        }
    },
    methods: {
        abrirConfirmacao(mensagem, acao) {
            this.confirmMessage = mensagem;
            this.confirmAction = acao;
            this.dialogConfirm = true;
        },
        executarConfirmacao() {
            if (this.confirmAction) this.confirmAction(); // executa a função passada
            this.dialogConfirm = false;                     // fecha o diálogo
        },
        confirmarSalvar() {
            this.dialogConfirm = false;
            this.saveZcinstancia();
        },
        async loadZcinstancias() {
            try {
                this.loading = true;
                const response = await this.axios.get('/siczap/instancias', {
                    params:{
                        disponivel: this.disponivel,
                        pendente: this.pendente,
                        indisponivel: this.indisponivel
                    }
                })
                this.zcinstancias = response.data.instancias;
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loading = false
            }
        },
        async loadZcinstancia(zcinstancia) {
            try {
                this.dialog = true;
                this.zcinstancia = zcinstancia;
                this.loadingDialog = true;
                const response = await this.axios.get(`/siczap/instancia/${this.zcinstancia.id}`);
                this.zcinstancia = response.data.instancia;
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loadingDialog = false
            }
        },
        async saveZcinstancia() {
            try {
                this.loadingNovo = true;
                await new Promise(resolve => setTimeout(resolve, 1000));
                await this.axios.post('/siczap/instancia')
                this.$store.dispatch('showSuccess', 'Instância criada com sucesso!');
                this.loadZcinstancias();
            } catch (error) {
                this.$store.dispatch('showError', error);
            }
            finally {
                this.dialogLoading = false;
                this.loadingNovo = false;
            }
        },
        async assinarZcinstancia() {
            try {
                this.loadingAssinarInstancia = true;
                await this.axios.post(`/siczap/instancia/${this.zcinstancia.id}/assinar`)
                this.$store.dispatch('showSuccess', 'Instância criada com sucesso!');
                this.dialog = false;
                this.loadZcinstancias();
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally{
                this.loadingAssinarInstancia = false;
            }
        },
        async cancelaZcinstancia(id) {
            try {
                this.loadingCancelar = id
                await this.axios.post(`/siczap/instancia/${id}/cancelar`)
                this.$store.dispatch('showSuccess', 'Instância cancelada com sucesso!');
                this.dialog = false;
                this.loadZcinstancias();
            } catch (error) {
                this.$store.dispatch('showError', error)
            }
            finally {
                this.loadingCancelar = null;
            }
        },
        async atualizarZcinstancia() {
            try {
                this.loadingSalvar = true;
                var request = {
                    zci_webhookurl_statusmsg: this.zcinstancia.zci_webhookurl_statusmsg
                }
                await this.axios.put(`/siczap/instancia/${this.zcinstancia.id}/atualizar`, request)
                this.$store.dispatch('showSuccess', 'Instância atualizada com sucesso!');
                this.dialog = false;
                this.loadZcinstancias();
            } catch (error) {
                this.$store.dispatch('showError', error)
            } finally {
                this.loadingSalvar = false;
            }
        }
    },
    mounted() {
        this.loadZcinstancias();
    },
    watch:{
        options:{

        },
        disponivel(){
            this.loadZcinstancias()
        },
        pendente(){
            this.loadZcinstancias()
        },
        indisponivel(){
            this.loadZcinstancias();
        }
    }
}
</script>
